module.exports = __webpack_public_path__ + "static/media/snake.03f8f0ed.svg";